import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, IconButton, Stack, styled, Typography } from '@mui/material'
import type { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import type { To } from 'react-router'
import { useNavigate } from 'react-router'

import { ICONS, LinkUnstyled, remUnit, unit } from '@hcr/ui'

import { Path } from '../../../../models'
import { to } from '../../../../utils'
import { LayoutBase } from '../../../common'

interface LayoutOnboardingInformationProps {
  button?: {
    label: string
    to: To
  }
  description: string
  headline: string
  image: ReactNode
}

export const LayoutOnboardingInformation: FC<LayoutOnboardingInformationProps> = ({
  button,
  description,
  headline,
  image,
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <LayoutBase>
      <Container>
        <StyledIconButton onClick={() => navigate(to(Path.Home))} aria-label={t('home.close')}>
          <FontAwesomeIcon icon={ICONS.farXmark} />
        </StyledIconButton>
        {image}
        <Stack component='main' sx={{ alignItems: 'center', gap: unit(2.5), textAlign: 'center' }}>
          <Typography variant='titleM'>{headline}</Typography>
          <Typography variant='bodyM'>{description}</Typography>
        </Stack>
        {button && (
          <Button component={LinkUnstyled} to={button.to} variant='contained' color='primary'>
            {button.label}
          </Button>
        )}
      </Container>
    </LayoutBase>
  )
}

const Container = styled(Stack)`
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: ${unit(7)};
  padding: ${unit(7)};
`

const StyledIconButton = styled(IconButton)`
  align-self: flex-end;
  position: absolute;
  top: ${unit(6)};
  right: ${unit(6)};
  cursor: pointer;
  font-size: ${remUnit(6)};
`
